import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent {
  @Input() chartType = 'pie';
  @Input() chartData: any = { labels: [], datasets: [] };
  @Input() chartOptions = {
    responsive: true,
    maintainAspectRatio: false
  };
}
